import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'

import { OpenConfirmation } from '@/store'

export const getAssignManagerAction = (workspaceId: ID, id: ID) =>
  OpenConfirmation({
    label: 'Confirm',
    message: 'Manager will have equal rights as team admin.',
    title: 'Assign manager',
    then: [
      DashboardActions.members.changeRole({
        id,
        workspaceId,
        role: 'MANAGER',
      }),
    ],
  })

export const getSuspendAction = (workspaceId: ID, id: ID) =>
  OpenConfirmation({
    label: 'Confirm',
    message: 'Suspended user will lose access to the team space.',
    title: 'Suspend user',
    then: [
      DashboardActions.members.suspend({
        id,
        workspaceId,
      }),
    ],
  })

export const getRemoveAction = (workspaceId: ID, id: ID) =>
  OpenConfirmation({
    label: 'Confirm',
    message: 'Removed user will lose access to the team space.',
    title: 'Remove from Team',
    then: [
      DashboardActions.members.delete({
        id,
        workspaceId,
      }),
    ],
  })
